/* My Pure Herb Clean — vanilla JS, no dependencies */
(function () {
  'use strict';
  var PH = window.PureHerb = window.PureHerb || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var ROOT = PH.root || '/';

  /* ---------- helpers ---------- */
  function esc(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // Same algorithm Shopify uses, driven by the store's own money format ("Rs. {{amount}}")
  function money(cents) {
    var format = PH.moneyFormat || '{{amount}}';
    var re = /\{\{\s*(\w+)\s*\}\}/;
    function fmt(n, p, t, d) {
      p = p == null ? 2 : p; t = t || ','; d = d || '.';
      if (isNaN(n) || n == null) return '0';
      var s = (n / 100).toFixed(p).split('.');
      return s[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + t) + (s[1] ? d + s[1] : '');
    }
    var m = format.match(re), v;
    switch (m ? m[1] : 'amount') {
      case 'amount_no_decimals': v = fmt(cents, 0); break;
      case 'amount_with_comma_separator': v = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': v = fmt(cents, 2, "'", '.'); break;
      default: v = fmt(cents, 2);
    }
    return format.replace(re, v);
  }
  PH.money = money;

  function toast(msg) {
    var t = $('#toast');
    if (!t) { t = document.createElement('div'); t.id = 'toast'; t.className = 'toast'; document.body.appendChild(t); }
    t.textContent = msg; t.classList.add('is-on');
    clearTimeout(t._h); t._h = setTimeout(function () { t.classList.remove('is-on'); }, 2600);
  }
  PH.toast = toast;

  /* ---------- panels: mobile nav, search, cart drawer ---------- */
  function overlay() {
    var o = $('#overlay');
    if (!o) { o = document.createElement('div'); o.id = 'overlay'; o.className = 'overlay'; document.body.appendChild(o); }
    return o;
  }
  function openPanel(el) {
    if (!el) return;
    closePanels();
    el.classList.add('is-open');
    overlay().classList.add('is-open');
    document.body.style.overflow = 'hidden';
    var f = el.querySelector('input,button,[href]');
    if (f) setTimeout(function () { f.focus(); }, 150);
  }
  function closePanels() {
    $$('.mnav.is-open,.search-modal.is-open,.cart-drawer.is-open').forEach(function (el) { el.classList.remove('is-open'); });
    overlay().classList.remove('is-open');
    document.body.style.overflow = '';
  }
  PH.closePanels = closePanels;

  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-open]');
    if (open) { e.preventDefault(); openPanel(document.getElementById(open.getAttribute('data-open'))); return; }
    if (e.target.closest('[data-close]') || e.target.id === 'overlay') closePanels();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closePanels(); });

  /* ---------- accordions (mobile nav, FAQ, product accordion) ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-toggle]');
    if (!t) return;
    e.preventDefault();
    var panel = document.getElementById(t.getAttribute('data-toggle'));
    if (!panel) return;
    var isOpen = t.getAttribute('aria-expanded') === 'true';
    t.setAttribute('aria-expanded', String(!isOpen));
    if (panel.classList.contains('faq__a')) panel.style.maxHeight = isOpen ? '0px' : panel.scrollHeight + 'px';
    else panel.hidden = isOpen;
  });

  /* ---------- tabs ---------- */
  document.addEventListener('click', function (e) {
    var tab = e.target.closest('[data-tab]');
    if (!tab) return;
    var scope = tab.closest('[data-tabs]');
    if (!scope) return;
    var name = tab.getAttribute('data-tab');
    $$('[data-tab]', scope).forEach(function (b) { b.setAttribute('aria-selected', String(b === tab)); });
    $$('[data-tab-panel]', scope).forEach(function (p) {
      var show = p.getAttribute('data-tab-panel') === name;
      p.hidden = !show;
      // carousels inside a just-revealed tab need their arrow state recalculated
      if (show) $$('[data-carousel-track]', p).forEach(function (t) { t.dispatchEvent(new Event('scroll')); });
    });
  });

  /* ---------- carousel ---------- */
  function initCarousel(root) {
    var track = $('[data-carousel-track]', root);
    if (!track || root._ready) return;
    root._ready = true;
    var prev = $('[data-carousel-prev]', root), next = $('[data-carousel-next]', root);
    function step() { var f = track.firstElementChild; return f ? f.offsetWidth + 20 : 300; }
    function sync() {
      if (!prev || !next) return;
      if (!track.clientWidth) return; // hidden (inactive tab): leave state alone
      prev.disabled = track.scrollLeft <= 4;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  }
  $$('[data-carousel]').forEach(initCarousel);

  /* ---------- slideshow ---------- */
  function initSlideshow(root) {
    var track = $('[data-slides]', root);
    if (!track || root._ready) return;
    root._ready = true;
    var slides = $$('.hero__slide', track), i = 0, timer = null;
    var dots = $$('[data-slide-dot]', root);
    var interval = parseInt(root.getAttribute('data-autoplay') || '0', 10);
    function go(n) {
      i = (n + slides.length) % slides.length;
      track.style.transform = 'translateX(' + (-100 * i) + '%)';
      dots.forEach(function (d, x) { d.setAttribute('aria-current', String(x === i)); });
      slides.forEach(function (s, x) { s.setAttribute('aria-hidden', String(x !== i)); });
    }
    function play() { stop(); if (interval > 0 && slides.length > 1 && !(window.Shopify && Shopify.designMode)) timer = setInterval(function () { go(i + 1); }, interval); }
    function stop() { clearInterval(timer); }
    root._go = function (n) { stop(); go(n); };
    var p = $('[data-slide-prev]', root), n = $('[data-slide-next]', root);
    if (p) p.addEventListener('click', function () { stop(); go(i - 1); play(); });
    if (n) n.addEventListener('click', function () { stop(); go(i + 1); play(); });
    dots.forEach(function (d, x) { d.addEventListener('click', function () { stop(); go(x); play(); }); });
    root.addEventListener('mouseenter', stop); root.addEventListener('mouseleave', play);
    var sx = 0;
    track.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; stop(); }, { passive: true });
    track.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - sx;
      if (Math.abs(dx) > 45) go(i + (dx < 0 ? 1 : -1));
      play();
    }, { passive: true });
    go(0); play();
  }
  $$('[data-slideshow]').forEach(initSlideshow);

  /* ---------- cart ---------- */
  function updateCartCount(count) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = count; el.hidden = count < 1; });
  }
  function refreshDrawer() {
    return fetch(ROOT + '?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-cart-drawer-inner]'), cur = $('[data-cart-drawer-inner]');
        if (fresh && cur) cur.innerHTML = fresh.innerHTML;
      });
  }
  PH.refreshCart = function () {
    return fetch(ROOT + 'cart.js').then(function (r) { return r.json(); }).then(function (c) {
      updateCartCount(c.item_count);
      return refreshDrawer().then(function () { return c; });
    });
  };
  function onCartPage() { return document.body.classList.contains('template-cart'); }

  function addToCart(form, btn) {
    var label = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.innerHTML = '<span class="spinner"></span>'; }
    return fetch(ROOT + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) { toast(res.data.description || res.data.message || 'Could not add to cart'); return; }
        return PH.refreshCart().then(function () {
          if (PH.cartType === 'drawer' && $('#cart-drawer')) openPanel($('#cart-drawer'));
          else toast('Added to cart');
        });
      })
      .catch(function () { toast('Network error, please try again'); })
      .then(function () { if (btn) { btn.disabled = false; btn.innerHTML = label; } });
  }
  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('form[data-add-to-cart]');
    if (!form) return;
    e.preventDefault();
    addToCart(form, form.querySelector('[type=submit]:not([data-shopify])'));
  });

  function changeLine(key, qty) {
    return fetch(ROOT + 'cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(function (c) {
      if (onCartPage()) { window.location.reload(); return c; }
      updateCartCount(c.item_count);
      return refreshDrawer().then(function () { return c; });
    });
  }
  document.addEventListener('click', function (e) {
    var rm = e.target.closest('[data-cart-remove]');
    if (rm) { e.preventDefault(); changeLine(rm.getAttribute('data-cart-remove'), 0); return; }
    var q = e.target.closest('[data-cart-qty]');
    if (q) { e.preventDefault(); changeLine(q.getAttribute('data-cart-qty'), Math.max(0, parseInt(q.getAttribute('data-qty'), 10) || 0)); return; }
    var step = e.target.closest('[data-qty-step]');
    if (step) {
      e.preventDefault();
      var input = step.parentElement.querySelector('input');
      input.value = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(step.getAttribute('data-qty-step'), 10));
    }
  });
  document.addEventListener('change', function (e) {
    var input = e.target.closest && e.target.closest('[data-cart-line-qty]');
    if (input) changeLine(input.getAttribute('data-cart-line-qty'), Math.max(0, parseInt(input.value, 10) || 0));
  });

  /* ---------- predictive search ---------- */
  var searchTimer;
  document.addEventListener('input', function (e) {
    var input = e.target.closest && e.target.closest('[data-predictive-input]');
    if (!input) return;
    var out = $('[data-predictive-results]');
    if (!out) return;
    clearTimeout(searchTimer);
    var q = input.value.trim();
    if (q.length < 2) { out.innerHTML = ''; return; }
    searchTimer = setTimeout(function () {
      fetch(ROOT + 'search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,collection&resources[limit]=8')
        .then(function (r) { return r.json(); })
        .then(function (d) {
          var res = d.resources.results;
          var items = (res.products || []).map(function (p) {
            var img = p.featured_image && p.featured_image.url
              ? '<img src="' + esc(p.featured_image.url) + '" alt="" loading="lazy" width="56" height="56">' : '';
            return '<a class="predictive__item" href="' + esc(p.url) + '">' + img +
              '<span><span class="predictive__title">' + esc(p.title) + '</span></span></a>';
          });
          (res.collections || []).forEach(function (c) {
            items.push('<a class="predictive__item" href="' + esc(c.url) + '"><span class="predictive__title">' + esc(c.title) + '</span></a>');
          });
          out.innerHTML = items.length
            ? items.join('') + '<a class="btn btn--outline btn--full" href="' + ROOT + 'search?q=' + encodeURIComponent(q) + '">' + esc(PH.strings.view_all) + '</a>'
            : '<p class="form-note">No results for &ldquo;' + esc(q) + '&rdquo;.</p>';
        })
        .catch(function () { out.innerHTML = ''; });
    }, 220);
  });

  /* ---------- product form: variants, price, stock, media ---------- */
  function initProductForm(root) {
    var data = $('[data-variants-json]', root);
    if (!data || root._ready) return;
    root._ready = true;
    var variants = JSON.parse(data.textContent);
    var idInput = $('[data-variant-id]', root), priceEl = $('[data-price]', root), compareEl = $('[data-compare]', root);
    var saveEl = $('[data-save]', root), btn = $('[data-add-btn]', root), stockEl = $('[data-stock]', root);
    var skuEl = $('[data-sku]', root), dynamic = $('[data-dynamic-checkout]', root);

    function selected() {
      var opts = [];
      $$('[data-option-index]', root).forEach(function (i) {
        if (i.tagName === 'SELECT' || i.checked) opts[parseInt(i.getAttribute('data-option-index'), 10)] = i.value;
      });
      return variants.filter(function (v) {
        return opts.every(function (o, i) { return o === undefined || v.options[i] === o; });
      })[0];
    }
    function render() {
      var v = selected();
      if (!v) {
        if (btn) { btn.disabled = true; btn.textContent = PH.strings.unavailable; }
        if (dynamic) dynamic.hidden = true;
        return;
      }
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.innerHTML = money(v.price);
      var onSale = v.compare_at_price && v.compare_at_price > v.price;
      if (compareEl) { compareEl.hidden = !onSale; compareEl.innerHTML = onSale ? money(v.compare_at_price) : ''; }
      if (saveEl) { saveEl.hidden = !onSale; if (onSale) saveEl.textContent = Math.round((1 - v.price / v.compare_at_price) * 100) + '% off'; }
      if (skuEl) { skuEl.textContent = v.sku || ''; skuEl.hidden = !v.sku; }
      if (stockEl) {
        if (!v.available) { stockEl.hidden = false; stockEl.textContent = PH.strings.sold_out; }
        else if (v.inventory_management && v.inventory_quantity > 0 && v.inventory_quantity <= 10) {
          stockEl.hidden = false; stockEl.textContent = PH.strings.low_stock.replace('999999', v.inventory_quantity);
        } else stockEl.hidden = true;
      }
      if (btn) { btn.disabled = !v.available; btn.textContent = v.available ? PH.strings.add_to_cart : PH.strings.sold_out; }
      if (dynamic) dynamic.hidden = !v.available;
      // keep the sticky bar in step with the chosen variant
      $$('[data-sticky-buy] input[name=id]').forEach(function (i) { i.value = v.id; });
      $$('[data-sticky-price]').forEach(function (el) { el.innerHTML = money(v.price); });
      if (v.featured_media) {
        var thumb = $('[data-thumb][data-media-id="' + v.featured_media.id + '"]', root);
        if (thumb) thumb.click();
      }
      try { var url = new URL(window.location); url.searchParams.set('variant', v.id); window.history.replaceState({}, '', url); } catch (err) {}
    }
    root.addEventListener('change', function (e) { if (e.target.closest('[data-option-index]')) render(); });
    render();
  }
  $$('[data-product-form]').forEach(initProductForm);

  /* ---------- product gallery ---------- */
  document.addEventListener('click', function (e) {
    var th = e.target.closest('[data-thumb]');
    if (!th) return;
    var root = th.closest('[data-gallery]'), main = root && $('[data-gallery-main]', root);
    if (!main) return;
    var img = document.createElement('img');
    img.src = th.getAttribute('data-src'); img.alt = th.getAttribute('data-alt') || ''; img.width = 1200; img.height = 1200;
    main.textContent = ''; main.appendChild(img);
    $$('[data-thumb]', root).forEach(function (t) { t.setAttribute('aria-current', String(t === th)); });
  });

  /* ---------- sticky buy bar ---------- */
  var sticky = $('[data-sticky-buy]'), anchor = $('[data-buy-anchor]');
  if (sticky && anchor && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      var en = entries[0];
      sticky.classList.toggle('is-on', !en.isIntersecting && en.boundingClientRect.top < 0);
    }).observe(anchor);
  }

  /* ---------- collection filtering (no page reload) ---------- */
  function fetchCollection(url) {
    var grid = $('[data-collection-grid]');
    if (grid) grid.style.opacity = '.45';
    return fetch(url).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var freshGrid = doc.querySelector('[data-collection-grid]'), curGrid = $('[data-collection-grid]');
      if (freshGrid && curGrid) curGrid.replaceWith(freshGrid);
      ['[data-pagination-wrap]', '[data-product-count]'].forEach(function (sel) {
        var f = doc.querySelector(sel), c = $(sel);
        if (c) c.innerHTML = f ? f.innerHTML : '';
      });
      window.history.pushState({ ph: 1 }, '', url);
    }).catch(function () { window.location.href = url; });
  }
  document.addEventListener('change', function (e) {
    var form = e.target.closest && e.target.closest('[data-facet-form]');
    if (!form) return;
    var params = new URLSearchParams();
    new FormData(form).forEach(function (v, k) { if (v !== '') params.append(k, v); });
    var qs = params.toString();
    fetchCollection(form.getAttribute('action') + (qs ? '?' + qs : ''));
  });
  document.addEventListener('click', function (e) {
    var pag = e.target.closest('[data-pagination-wrap] a');
    if (pag) { e.preventDefault(); fetchCollection(pag.href).then(function () { window.scrollTo({ top: 0, behavior: 'smooth' }); }); return; }
    var btn = e.target.closest('.facet__btn');
    if (btn) {
      e.preventDefault();
      var panel = btn.nextElementSibling;
      $$('.facet__panel').forEach(function (p) { if (p !== panel) p.hidden = true; });
      if (panel) panel.hidden = !panel.hidden;
      return;
    }
    if (!e.target.closest('.facet')) $$('.facet__panel').forEach(function (p) { p.hidden = true; });
  });
  window.addEventListener('popstate', function (e) { if ($('[data-collection-grid]') && e.state && e.state.ph) window.location.reload(); });

  /* ---------- theme editor hooks ---------- */
  document.addEventListener('shopify:section:load', function (e) {
    $$('[data-carousel]', e.target).forEach(initCarousel);
    $$('[data-slideshow]', e.target).forEach(initSlideshow);
    $$('[data-product-form]', e.target).forEach(initProductForm);
  });
  document.addEventListener('shopify:block:select', function (e) {
    var root = e.target.closest && e.target.closest('[data-slideshow]');
    if (root && root._go) root._go($$('.hero__slide', root).indexOf(e.target));
  });
  document.addEventListener('shopify:section:select', function (e) {
    if (e.target.querySelector && e.target.querySelector('#cart-drawer')) openPanel($('#cart-drawer'));
  });
  document.addEventListener('shopify:section:deselect', closePanels);
})();
